module.exports = __webpack_public_path__ + "images/map/map-marker-3d82c6c4dada1c39f8e77348c2a388ed.svg";